import { render } from "./Bustour.vue?vue&type=template&id=27b88117&scoped=true"
import script from "./Bustour.vue?vue&type=script&lang=js"
export * from "./Bustour.vue?vue&type=script&lang=js"

import "./Bustour.vue?vue&type=style&index=0&id=27b88117&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b88117"]])

export default __exports__